/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Nav_LabelInputs */

const en_cap_nav_label = /** @type {(inputs: Cap_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinds of system`)
};

const lv_cap_nav_label = /** @type {(inputs: Cap_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistēmu veidi`)
};

/**
* | output |
* | --- |
* | "Kinds of system" |
*
* @param {Cap_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_nav_label = /** @type {((inputs?: Cap_Nav_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Nav_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_nav_label(inputs)
	return en_cap_nav_label(inputs)
});